import React, { useState, useContext, useEffect } from "react";
import "../../../assets/css/milestone.css";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import MockTooltipComponent from "../MockTooltipComponent";
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { userJourneyContext } from "../../../states/context/userJourneyContext";
import { getProgress, updateUserJourneyState } from "../mockUtils";

const MockMessageComponent = (props) => {
  const classes = useStyles();
  const [openAlert, setOpenAlert] = React.useState(false);
  const userContext = useContext(userJourneyContext);
  const [showInfo, setShowInfo] = useState(false)
  const [showMessage, setShowMessage] = useState(false)

  const handleClick = () => {
    setOpenAlert(true);
    setShowInfo(false)
    setTimeout(() => {
      if (userContext.userJourneyInfo.payload.steps === 14) {
        (async () => {
          try {
            userContext.setUserJourneyInfo(
              updateUserJourneyState(userContext.userJourneyInfo)
            );
            userContext.setUserJourneyProgress(
              getProgress(userContext.userJourneyProgress)
            );
          } catch (e) {
            console.log(e);
          }
        })();
      }
      window.scrollTo({ top: 100, left: 0, behavior: 'smooth' });
    }, 800);
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  useEffect(() => {
    if (userContext.userJourneyInfo.payload.steps === 14) {
      setShowInfo(true)
      setShowMessage(true)
    }
    if (userContext.userJourneyInfo.payload.steps === 15) {
      setShowMessage(true)
    }
  }, [userContext.userJourneyInfo.payload.steps]);

  return (
    <>
      <div className="message-data-div">
        <>
          <button
            className="btn btn-email1"
          >
            <img src={require(`../../../assets/images/email.png`).default} />
            <span className="btn-text">Email</span>
          </button>
          {showMessage ? <div>
            <div className="topDetailsDiv">
              <span className="supplierUpdate">FW: Supplier Updates12</span>
              <div className="messageStyle">
                <span className="compose_mail_vessel_id">Kavida - PO: #12087633979</span><br />
                <span>Recipient: Jay Shetty </span><br />
                <span>Sender: Jones Ferdinand</span>
              </div>
            </div>
            <div className="mainMessageStyle">
              <p>Hi Jay,</p>
              <p>Thanks for informing us about the risk. Safe to say that it won’t affect <br />the timeline of this PO.</p>
              <div className="onlyFlexStyle">
                <MockTooltipComponent
                  placement="left"
                  open={userContext.userJourneyInfo.payload.steps === 14 ? !props.beforeEmail : false}
                  popper={classes.getTrackingIDPopperTooltip}
                  title={
                    <>
                      <Typography className={classes.tooltipTitleStyle}>
                        Copy Vessel Tracking ID
                      </Typography>
                      <p className={classes.tooltipTextStyle}>
                        Your supplier has replied with a vessel number for
                        your shipment.
                      </p>
                      <p className={classes.tooltipTextStyle}>
                      Click on this number to copy.
                      </p>
                      <Typography className={classes.stepTextStyle}>
                        (11/19)
                      </Typography>
                    </>
                  }
                  child={
                    <p>It has just been shipped for delivery. <br />Here’s the tracking ID:
                      <u onClick={(e) => {
                        navigator.clipboard.writeText("129347128937");
                        handleClick(e);
                      }}>129347128937</u></p>
                  }
                />
                <Alert style={showInfo ? {
                  height: "38px",
                  width: "250px",
                  padding: "0px",
                  paddingLeft: "10px",
                  marginTop: "20px",
                  marginLeft: "8px"
                } : { display: "none" }}
                  variant="filled"
                  severity="info"
                  onClick={(e) => {
                    navigator.clipboard.writeText("129347128937")
                    handleClick(e);
                  }}>
                  Click Tracking ID to copy
                </Alert>
              </div>
              <div>
                <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleClose}>
                  <Alert onClose={handleClose} severity="success">
                    Copied
                  </Alert>
                </Snackbar>
              </div>
            </div>
          </div> : <div>
            <div className="topDetailsDiv">
              <span className="supplierUpdate">FW: Supplier Updates</span>
              <div className="messageStyle">
                <span className="compose_mail_vessel_id">Kavida - PO: #47583012399</span><br />
                <span>Recipient: Chen Lin </span><br />
                <span>Sender: kavida</span>
              </div>
            </div>
            <div className="mainMessageStyle">
              <p>Hi Chen Lin,</p>
              <p>We've detected some risk for the purchase order with number NP784523. The risks in China dents battery metals demand.</p>
              <div>
                <p>Please let us know if these risks are affecting the delivery.</p>
              </div>
            </div>
          </div>}
          <div className="email-link-container">
            <a className="email-reply-link">Reply</a>
            <a className="email-reply-link">Reply All</a>
            <a className="email-reply-link">Forward</a>
          </div>
        </>
      </div>
      <div className="message-data-div">
        <>
          <button
            className="btn btn-whatsapp1"
          >
            <img style={{ color: "black" }} src={require(`../../../assets/images/whatsappBlack.png`).default} />
            <span className="btn-text">Whatsapp</span>
          </button>
          <div className="topDetailsDiv">
            <div className="messageStyle">
              <span className="compose_mail_vessel_id">Kavida - PO: #12087633979</span><br />
              <span>Recipient: Jayasinghe Sangakkara </span><br />
              <span>Sender: Jones Ferdinand</span>
            </div>
          </div>
          <div className="mainMessageStyle">
            <p>Dear Jayasinghe Sangakkara,</p>

            <p>We need an urgent update for PO # 12087633979 as we have not heard from you. Please provide us an update of the expected delivery date ASAP.
            </p>
            <p>
              Jones Ferdinand<br />
              Procurement Mananager</p>
          </div>
          <div className="email-link-container">
            <a className="email-reply-link">Reply</a>
          </div>
        </>
      </div>
    </>
  );
};
export default MockMessageComponent;

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    margin: 0
  },
  getTrackingIDPopperTooltip: {
    zIndex: "1"
  },
  tooltipTitleStyle: {
    marginTop: "0px",
    fontSize: "20px",
    fontFamily: "Inter",
    fontWeight: 600,
    marginBottom: "8px",
  },
  tooltipTextStyle: {
    marginTop: "0px",
    fontSize: "14px",
    fontFamily: "Inter",
    lineHeight: "20px",
    fontWeight: 400,
  },
  stepTextStyle: {
    padding: "0px",
    margin: "0px",
    fontSize: "14px",
    textAlign: "end",
    marginTop: "-10px",
    marginBottom: "-10px",
  }
}));